import { render } from "./ChemistryBlock.vue?vue&type=template&id=2acc4638&scoped=true"
import script from "./ChemistryBlock.vue?vue&type=script&lang=js"
export * from "./ChemistryBlock.vue?vue&type=script&lang=js"

import "./ChemistryBlock.vue?vue&type=style&index=0&id=2acc4638&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acc4638"]])

export default __exports__